import { render } from "./alarm-efficiency.vue?vue&type=template&id=8fdd2c3e"
import script from "./alarm-efficiency.vue?vue&type=script&lang=js"
export * from "./alarm-efficiency.vue?vue&type=script&lang=js"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__